<template>
   <div>
      <b-container>
         <QuestionnairesTitle title="Questionnaires" />
      </b-container>
      <QuestionnaireAnswerForm v-if="loaded" @refresh="fetchData" is-project />
   </div>
</template>

<script>
import QuestionnaireAnswerForm from './widgets/QuestionnaireAnswerForm.vue';
import QuestionnairesTitle from '../../components/QuestionnairesTitle.vue';
import {mapGetters} from 'vuex';

export default {
   components: {
      QuestionnairesTitle,
      QuestionnaireAnswerForm,
   },

   data() {
      return {
         loaded: false,
      };
   },

   computed: {
      ...mapGetters({
         activeStudyId: 'companies/activeStudyId',
         hasQuestionnaireAssignment: 'progress/hasQuestionnaireAssignment',
      }),

      projectId() {
         return this.$route.params.projectId;
      },

      questionnaireId() {
         return this.$route.params.questionnaireId;
      },

      companyId() {
         return this.$route.params.id;
      },
   },

   methods: {
      // Load the questionnaire data
      async fetchData() {
         const requests = [];

         requests.push(
            this.$store.dispatch('questionnaire/loadProjectQuestionnaire', {
               questionnaireId: this.questionnaireId,
               joinProject: true,
            })
         );

         requests.push(this.$store.dispatch('users/loadCompanyUsers', {companyId: this.companyId}));
         requests.push(
            this.$store.dispatch('questionnaire/loadQuestionnaires', {companyId: this.companyId})
         );

         await this.loadPage(requests);
         this.loaded = true;
      },
   },

   async created() {
      await this.fetchData();
   },

   watch: {
      async activeStudyId() {
         if (this.isActiveStudyInSetupStage) {
            this.$router.push({name: 'Home'});
            return;
         }
         if (!this.hasQuestionnaireAssignment) {
            this.$router.push({name: 'Home'});
         } else {
            this.loaded = false;
            await this.fetchData();
         }
      },
   },
};
</script>
